export class ArrayUtils {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static unshift<T = any>(
    arr: T[],
    element: T,
    maxSize = Infinity
  ): void {
    arr.unshift(element);

    if (maxSize > -1 && arr.length >= maxSize) {
      arr.splice(maxSize);
    }
  }
}
